<template>
  <div class="account-setting">
    <div style="margin-top: 1rem">
      <van-icon name="arrow-left" @click="subtractMonth" />
      <span style="margin: 0 1rem">{{ year + "年" + month + "月" }}</span>
      <van-icon name="arrow" @click="plusMonth" />
    </div>
    <van-tabs v-model="active" style="margin-top: 1rem" @click="clickTab">
      <van-tab title="直营合作伙伴">
        <div class="Lists">
          <van-cell-group
            v-if="datas != null && datas.length > 0 ? true : false"
          >
            <van-cell
              class="Lists_cell"
              :title="item.outStockMerchantFullName"
              :value="item.amount / 100 + '元'"
              :label="item.gmtCreate"
              v-for="(item, index) in datas"
              :key="index"
            />
          </van-cell-group>
          <div v-else>
            <van-empty description="当月直营合作伙伴未有出库明细" />
          </div>
        </div>
      </van-tab>
      <van-tab title="省内合作伙伴">
        <div class="Lists">
          <van-cell-group
            v-if="proxies != null && proxies.length > 0 ? true : false"
          >
            <van-cell
              class="Lists_cell"
              :title="items.outStockMerchantName"
              :label="items.gmtCreate"
              :value="items.amount / 100 + '元'"
              v-for="(items, indexs) in proxies"
              :key="indexs"
            />
          </van-cell-group>
          <div v-else>
            <van-empty description="当月省内合作伙伴未有出库明细" />
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="bottoms">
      <div style="margin-top: 1.5rem">
        <span class="shop_span">{{
          !active
            ? source.childMerchantAmount / 100
            : source.proxyMerchantAmount / 100
        }}</span>
        <p class="shop_p">当月出库金额(元)</p>
      </div>
    </div>

    <!-- 弹出框 -->
    <!-- <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @formatter="formatter"
        @confirm="confirm"
        @cancel="show = false"
      />
    </van-popup> -->
  </div>
</template>

<script>
import { list_proxy, list, report } from "@/api/exwarehouse";
export default {
  data() {
    return {
      active: this.$route.params.active,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      show: false,
      times: "",
      source: {},
      datas: [],
      proxies: [],
      year: "",
      month: "",
    };
  },
  mounted() {
    this.List();
  },
  methods: {
    List() {
      var time = new Date();
      this.year = time.getFullYear();
      this.month = time.getMonth() + 1;
      if (!this.active) {
        list(this.year, this.month)
          .then((res) => {
            this.datas = res.result.rows;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        list_proxy(this.year, this.month)
          .then((resr) => {
            this.proxies = resr.result;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.salesReport(this.year, this.month);
    },

    // confirm(value) {
    //   this.datas = [];
    //   this.proxies = [];
    //   let year = value.getFullYear();
    //   let month = value.getMonth() + 1;
    //   this.times = year + "年" + month + "月";
    // if (!this.active) {
    //   list(year, month)
    //     .then((res) => {
    //       this.datas = res.result.rows;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // } else {
    //   list_proxy(year, month)
    //     .then((resr) => {
    //       this.proxies = resr.result;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // }
    //   this.show = false;
    //   this.salesReport(year, month);
    // },

    // 向前加一个月
    plusMonth() {
      this.datas = [];
      this.proxies = [];
      const NewYear = new Date().getFullYear();
      const NewMonth = new Date().getMonth() + 1;
      // 当前设置月份 与 获取最新时间月份转成字符串 再判断
      if (this.year + "-" + this.month != NewYear + "-" + NewMonth) {
        this.month = this.month + 1;
        if (this.month == 13) {
          this.year = this.year + 1;
          this.month = 1;
        }
        if (!this.active) {
          list(this.year, this.month)
            .then((res) => {
              this.datas = res.result.rows;
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          list_proxy(this.year, this.month)
            .then((resr) => {
              this.proxies = resr.result;
            })
            .catch((err) => {
              console.log(err);
            });
        }
        this.salesReport(this.year, this.month);
      } else {
        this.$toast("已是最新时间!");
      }
    },
    // 向后减一个月
    subtractMonth() {
      this.datas = [];
      this.proxies = [];
      const minimumTime = "2015-1";
      if (this.year + "-" + this.month != minimumTime) {
        this.month = this.month - 1;
        if (this.month == 0) {
          this.year = this.year - 1;
          this.month = 12;
        }
        if (!this.active) {
          list(this.year, this.month)
            .then((res) => {
              this.datas = res.result.rows;
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          list_proxy(this.year, this.month)
            .then((resr) => {
              this.proxies = resr.result;
            })
            .catch((err) => {
              console.log(err);
            });
        }
        this.salesReport(this.year, this.month);
      } else {
        this.$toast("已是最早时间!");
      }
    },
    clickTab(name) {
      if (!name) {
        this.datas = [];
        this.proxies = [];
        list(this.year, this.month)
          .then((res) => {
            this.datas = res.result.rows;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        list_proxy(this.year, this.month)
          .then((resr) => {
            console.log(resr,"1111")
            this.proxies = resr.result;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.salesReport(this.year, this.month);
    },
    salesReport(year, month) {
      report(year, month)
        .then((res) => {
          this.source = res.result;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.account-setting {
  position: relative;
  height: 96vh;
  .Lists {
    width: 85%;
    margin: 1rem auto;
    text-align: initial;
    height: 400px;
    overflow-y: scroll;
    .Lists_cell {
      margin: 1rem 0;
    }
  }
  .bottoms {
    position: absolute;
    bottom: -10px;
    width: 100%;
    height: 100px;
    box-shadow: 0px 0px 20px #c5c5c5;
    .shop_span {
      color: #1c86dc;
      font-size: 1.4rem;
    }
    .shop_p {
      margin: 0.5rem 0;
    }
  }
}
</style>
